import { ConfirmDialog, LinearProgress, Typography } from '@occc/ui-design-system';

type RemoveUserFromRetailerNetworkDialogProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  onConfirm: () => void;
  isRemoveUserFromRetailerNetworkInProgress?: boolean;
};

export const RemoveUserFromRetailerNetworkDialog = ({
  open,
  setOpen,
  onConfirm,
  isRemoveUserFromRetailerNetworkInProgress,
}: RemoveUserFromRetailerNetworkDialogProps) => (
  <ConfirmDialog
    dialogTitle='Remove User From Retailer Network'
    confirmButtonText='Remove'
    open={open}
    onClose={() => setOpen(false)}
    confirmButtonProps={{
      onClick: onConfirm,
      color: 'error',
      disabled: isRemoveUserFromRetailerNetworkInProgress,
    }}
  >
    {isRemoveUserFromRetailerNetworkInProgress && <LinearProgress />}

    <Typography>
      Are you sure you would like to remove this User from this Retailer Network?
    </Typography>
  </ConfirmDialog>
);
